import { NoddiIcon, type NoddiIconName, cva } from 'noddi-ui-common';
import { type KindTone } from 'noddi-util';

const kindPipVariants = cva('flex shrink-0 items-center justify-center rounded-md', {
  variants: {
    tone: {
      blue: 'bg-blue50 text-blue-900',
      purple: 'bg-lightPurple text-darkPurple',
      coral: 'bg-coral text-noddiOrange50',
      green: 'bg-success20 text-successDark'
    },
    size: {
      small: 'size-6',
      medium: 'size-8',
      large: 'size-10'
    }
  }
});

interface Props {
  icon: NoddiIconName;
  tone: KindTone;
  size: 'small' | 'medium' | 'large';
}

export const KindPip = ({ icon, tone, size }: Props) => (
  <span className={kindPipVariants({ tone, size })} aria-hidden>
    <NoddiIcon name={icon} size={size === 'large' ? 'medium' : 'small'} />
  </span>
);
